import { Flex, FlexProps, useStyleConfig } from '@chakra-ui/react';

interface MainContainerProps extends FlexProps {
  variant?: string;
}

export const MainContainer = ({ variant, ...rest }: MainContainerProps) => {
  const styles = useStyleConfig('MainContainer', { variant });

  // Pass the computed styles into the `__css` prop
  return <Flex __css={styles} {...rest} />;
};
